import Cookies from "js-cookie";

const Key = "Admin-Token";

export function getToken() {
  return localStorage.getItem(Key) || Cookies.get(Key);
}

export function setToken(token) {
  localStorage.setItem(Key, token);
  Cookies.set(Key, token);
}

export function removeToken() {
  localStorage.removeItem(Key);
  Cookies.remove(Key);
}
